import { render, staticRenderFns } from "./ApprovalPerformance.vue?vue&type=template&id=126ba5e4&scoped=true&"
import script from "./ApprovalPerformance.vue?vue&type=script&lang=js&"
export * from "./ApprovalPerformance.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalPerformance.vue?vue&type=style&index=0&id=126ba5e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126ba5e4",
  null
  
)

export default component.exports